<lio-disclosure *ngIf="displayModel" [model]="model"></lio-disclosure>